/**
 * Default child filter search
 */
var childFilter = {
    childApiUrl: '/api/children/json/child-sponsorship/',
    continentEl: '#continent',
    countryEl: '#country',
    countryGenderForm: '#filter-by-country-gender',
    countryOptionEl: '#country option',
    filterItems: '#filters-container .filter-item',
    filterItemsWrapper: '#filters-container .filter-items',
    filterItemTrigger: '#filters-container .filter-item .filter-trigger',
    filterItemContent: '#filters-container .filter-item .filter',
    filterItemLabelTrigger: '#filters-container .item-label',
    originalCountries: null,
    init: function () {
        childFilter.setOriginalCountries();
        childFilter.filterCountryByContinent();
        childFilter.rangeFilters();
        childFilter.formSubmit();
        childFilter.filterSidebar();
    },
    setOriginalCountries: function () {
        var $countryEl = $(childFilter.countryEl);
        childFilter.originalCountries = $countryEl.html();
    },
    filterCountryByContinent: function () {
        var $continentEl = $(childFilter.continentEl),
            $countryEl = $(childFilter.countryEl),
            $continent;

        $continentEl.change(function (e) {
            e.preventDefault();
            $continent = $(this).val(),
            $continent = $continent.toLowerCase(),
            $continent = $continent.replace(' ', ''),
            $continent = $continent.replace('easterneurope', 'europe');

            /** Reset the country options with the default options */
            $countryEl.html(childFilter.originalCountries);

            /** Grab the options after we reset */
            var $countryOptionEl = $(childFilter.countryOptionEl);

            /** We only want to filter when "any" isn't selected */
            if ($continent !== 'any') {
                /** Loop through the options and remove the ones we do not want */
                $countryOptionEl.each(function (index, element) {
                    var $element = $(element),
                        $elementContinent = $element.data('continent');

                    /** Remove the <options> that aren't matched in the statement below */
                    if ($elementContinent !== 'any' && $elementContinent !== $continent) {
                        $element.remove();
                    }
                });
            }
        });
    },
    rangeFilters: function () {
        $('.btn-group a').click(function (e) {
            e.preventDefault();

            /** Remove the active button state from the active one */
            $(this).parent().find('a').removeClass('btn-active');

            /** Set the active one */
            $(this).addClass('btn-active');

            /** Set the hidden form field to have the right value */
            var $value = $(this).data('value');
            $(this).parent().next('input').val($value);

        });
    },
    formSubmit: function () {
        var $form = $(childFilter.countryGenderForm);
        $form.not('.no-ajax').submit(function (e) {
            e.preventDefault();

            /** Trigger page loading */
            pageLoad.startLoading();

            /** Hide any leftover No Children messages */
            sponsorshipResultsMessages.hide();

            /** Serialize the form data */
            var $formData = $(this).serialize();
            /** Append the page ID to the form data */
            $formData += '&cID=' + CCM_CID;
            $formData = $formData.replace('Eastern+Europe', 'Europe');

            $.ajax({
                url: childFilter.childApiUrl,
                context: document.body,
                data: $formData,
                dataType: 'html',
                type: 'get'
            }).done(function ($response) {
                var $responseJson = JSON.parse($response),
                    $tokenValue = $responseJson.new_token,
                    $children = $responseJson.children,
                    $childrenJson = JSON.stringify($children),
                    $totalChildren = $children.length,
                    $startIndex = 0;

                /** Complete page loading */
                pageLoad.endLoading();

                /** Update the token value with the new one from the response */
                childFilter.updateTokenValue($tokenValue);

                /** Handle no children message */
                if ($responseJson.show_no_child_notice === true) {
                    sponsorshipResultsMessages.message = $responseJson.message;
                    sponsorshipResultsMessages.show();
                }

                /** Update the child navigation values and init the childNavigation */
                if ($totalChildren > 0) {
                    childNavigation.json = $childrenJson;
                    childNavigation.startIndex = $startIndex;
                    childNavigation.totalChildren = $totalChildren;
                    childNavigation.currentChild = $children[$startIndex];
                    childNavigation.decode();
                    childNavigation.setStartChild();
                    childNavigation.setCurrentChildIndex($startIndex);
                    childNavigation.lastChildIndex = parseInt($totalChildren) - 1;

                    /** Manually update the child result to the first of the filtered children */
                    childNavigation.updateChild();

                    /** Manually unhide the child navigation as there are some journeys that hide it */
                    childFilter.updateNavigation();
                }

                /** col-xs */
                if (window.matchMedia('screen and (max-width:767px)').matches) {
                    /** On mobile only, close the filters after searching */
                    // childFilter.deactivateAll();
                    childFilter.hideParent();
                }
            });
        });
    },
    updateTokenValue: function (value) {
        $(childFilter.countryGenderForm + ' input[name="ccm_token"]').val(value);
    },
    filterSidebar: function () {
        // var $collapseElement = $(childFilter.filterItemContent);
        //
        // $collapseElement.on('hide.bs.collapse', function(e) {
        //     var $parent = $($(e.target).data('parent'));
        //     /** Make this one active */
        //     $parent.removeClass('active');
        //     /** Unhide the hidden */
        //     childFilter.unhideHidden();
        // });
        //
        // $collapseElement.on('show.bs.collapse', function(e) {
        //     var $parent = $($(e.target).data('parent'));
        //
        //     /** Make this one active */
        //     $parent.addClass('active');
        //     /** Hide the rest */
        //     childFilter.hideInactive();
        // });

        var $element = $(childFilter.filterItemTrigger);
        $element.click(function (e) {
            e.preventDefault();
            var $this = $(this),
                $parent = $this.parent();

            if (! $(this).hasClass('disable-accordion')) {

                /** Check if it's already active */
                if ($parent.hasClass('active')) {
                    /** Make this one active */
                    $parent.removeClass('active');
                    /** Unhide the hidden */
                    childFilter.unhideHidden();
                } else {
                    /** Make this one active */
                    $parent.addClass('active');
                    /** Hide the rest */
                    childFilter.hideInactive();
                }
            }
        });

        /** col-xs */
        if (window.matchMedia('screen and (max-width:767px)').matches) {
            childFilter.mobileControls();
        }

        /** col-sm */
        if (window.matchMedia('screen and (min-width: 768px) and (max-width: 991px)').matches) {
            childFilter.mobileControls();
        }

        if (window.matchMedia('screen and (min-width: 990px)').matches) {
            childFilter.resetEvent();
        }
    },
    deactivateAll: function () {
        var $elements = $(childFilter.filterItems);
        $.each($elements, function (index, element) {
            var $element = $(element);
                $element.removeClass('active');
                $element.removeClass('hide');
        });
    },
    hideInactive: function () {
        var $elements = $(childFilter.filterItems);
        $.each($elements, function (index, element) {
            var $element = $(element);
            if (! $element.hasClass('active')) {
                $element.addClass('hide');
            }
        });
    },
    unhideHidden: function () {
        var $elements = $(childFilter.filterItems);
        $.each($elements, function (index, element) {
            var $element = $(element);
            if ($element.hasClass('hide')) {
                $element.removeClass('hide');
            }
        });
    },
    updateNavigation: function () {
        $('#child-results .left').removeClass('hide');
        $('#child-results .right').removeClass('hide');

        if (childNavigation.totalChildren <= 1) {
            $('#child-results .left').addClass('hide');
            $('#child-results .right').addClass('hide');
        }
    },
    mobileControls: function () {
        childFilter.clickEvent();
    },
    hideParent: function () {
        var $parentElement = $(childFilter.filterItemsWrapper),
            $labelElement = $(childFilter.filterItemLabelTrigger);

        $parentElement.addClass('hidden-xs hidden-sm');
        $labelElement.removeClass('active');
    },
    showParent: function () {
        var $parentElement = $(childFilter.filterItemsWrapper),
            $labelElement = $(childFilter.filterItemLabelTrigger);

        $parentElement.removeClass('hidden-xs hidden-sm');
        $labelElement.addClass('active');
    },
    clickEvent: function () {
        var $labelElement = $(childFilter.filterItemLabelTrigger);
        $labelElement.not('.disable-accordion').click(function (e) {
            e.preventDefault();
            if ($(this).hasClass('active')) {
                childFilter.hideParent();
            } else {
                childFilter.showParent();
            }
        });
    },
    resetEvent: function () {
        var $labelElement = $(childFilter.filterItemLabelTrigger);
        $labelElement.not('.disable-accordion').click(function (e) {
            e.preventDefault();
            if (! $(this).hasClass('disable-accordion')) {
                childFilter.deactivateAll();
            }
        });
    }
};

/**
 * Manage child carousel
 */
var childNavigation = {
    /** json, startIndex, totalChildren are set in the page_type as they're grabbed from the page_type controller */
    json: null,
    startIndex: 0,
    totalChildren: null,
    data: {},
    startChild: null,
    carouselId: '#child-results',
    currentChildIndex: null,
    currentChild: null,
    /** Different to startIndex as startIndex is the child we start with, firstChildIndex is the first child in data */
    firstChildIndex: 0,
    lastChildIndex: null,
    init: function () {
        childNavigation.decode();
        childNavigation.setStartChild();
        childNavigation.changeChild();

        /** Set initial child index to the startIndex */
        childNavigation.setCurrentChildIndex(childNavigation.startIndex);
        /** Set the last child index to be the total minus 1 (index starts from 0) */
        childNavigation.lastChildIndex = parseInt(childNavigation.totalChildren) - 1;
        /** Ensure that the currentChild variable holds the first child too, as otherwise this is only populated on change */
        childNavigation.currentChild = childNavigation.data[childNavigation.currentChildIndex];
    },
    decode: function () {
        childNavigation.data = JSON.parse(childNavigation.json);
    },
    setStartChild: function () {
        childNavigation.startChild = childNavigation.data[childNavigation.startIndex];
    },
    setCurrentChildIndex: function (index) {
        childNavigation.currentChildIndex = parseInt(index);
    },
    changeChild: function () {
        $(childNavigation.carouselId + ' .control').click(function (e) {
            e.preventDefault();

            if (! $(this).attr('disabled')) {
                var $direction = $(this).data('direction'),
                    $nextIndex,
                    $previousIndex,
                    $childIndex;

                /** Disable child navigation until the video's loaded */
                childNavigation.disableNavigation();

                /** When the current child is lower than total children we have */
                if (childNavigation.currentChildIndex < childNavigation.totalChildren) {
                    /** Next child to be plus 1 */
                    $nextIndex = childNavigation.currentChildIndex + 1;
                    /** Previous child to be minus 1 */
                    $previousIndex = childNavigation.currentChildIndex - 1;
                }

                /** When the current child is the first child */
                if (childNavigation.currentChildIndex === 0) {
                    /** Previous child to be the last child */
                    $previousIndex = childNavigation.lastChildIndex;
                }

                /** When the current child the last child */
                if (childNavigation.currentChildIndex === childNavigation.lastChildIndex) {
                    /** Next child to be the first child */
                    $nextIndex = childNavigation.firstChildIndex;
                }

                /** Change the child we're displaying based on which direction we're going */
                if ($direction === 'next') {
                    $childIndex = $nextIndex;
                } else {
                    $childIndex = $previousIndex;
                }

                /** Update the object scope of the child */
                childNavigation.currentChildIndex = $childIndex;
                childNavigation.currentChild = childNavigation.data[childNavigation.currentChildIndex];

                /** Update the page content */
                childNavigation.updateChild();

                /** Google Tag Manager event for the carousel arrow **/
                if ( $direction == 'next' ) {
                    dataLayerTracking.childChange('browse-next-click');
                } else {
                    dataLayerTracking.childChange('browse-prev-click');
                }
            }
        });
    },
    updateChild: function () {
        childNavigation.updateVideo();
        childNavigation.updateChildInfo();
        childNavigation.updateCommunity();
    },
    updateVideo: function () {
        if ($("#"+childVideo.videoElementId).length) {
            if (childNavigation.currentChild.video !== '') {
                var $video = document.getElementById(childVideo.videoElementId),
                    $videoModal = document.getElementById(childVideo.videoModalElementId),
                    $source = document.createElement('source');

                /** Update child name in video content */
                /** @TODO: switch this (and the markup) to .child-name */
                $('#child-name-video').html(childNavigation.currentChild.name);

                /** Remove the video source element */
                $($video).find('source').remove();

                /** Remove the video source element from the modal */
                $($videoModal).find('source').remove();

                /** Append the newly created source element and add the video src */
                $video.appendChild($source);
                $video.src = childNavigation.currentChild.video;
                $source.setAttribute('src', childNavigation.currentChild.video);

                /** Append the newly created source element and add the video src to the modal */
                $videoModal.appendChild($source);
                $videoModal.src = childNavigation.currentChild.video;
                $videoModal.setAttribute('src', childNavigation.currentChild.video);

                /** Reload the video element and start playing */
                $video.load();
                $video.play();

                /** Reload the video element on the modal */
                $videoModal.load();

                /** col-xs */
                if (window.matchMedia('screen and (max-width:767px)').matches) {
                    childVideo.init();
                }

                /** Once the video has loaded, re-enable the child navigation */
                $video.addEventListener('loadeddata', function () {
                    childNavigation.enableNavigation();
                });
            } else {
                /** Just in case there's no video, re-enable the child navigation */
                childNavigation.enableNavigation();
            }
        } else {
            childNavigation.enableNavigation();
        }
    },
    updateChildInfo: function () {
        $('.sponsor-js-change .child-name').html(childNavigation.currentChild.firstname);
        $('.sponsor-js-change .child-country-name').html(childNavigation.currentChild.country.name);
        $('.sponsor-js-change .child-community-name').html(childNavigation.currentChild.community.name);
        $('.sponsor-js-change .child-gender-heshe').html(childNavigation.currentChild.gender_heshe);
        $('.sponsor-js-change .child-gender-hisher').html(childNavigation.currentChild.gender_hisher);
        $('.sponsor-js-change .child-gender-himher').html(childNavigation.currentChild.gender_himher);
        $('.sponsor-js-change .child-weather-temp').html(childNavigation.currentChild.weather.temp);
        $('.sponsor-js-change .child-weather-name').html(childNavigation.currentChild.weather.name);
        $('.sponsor-js-change .child-birthday-month').html(childNavigation.currentChild.birthday_month);
        $('.sponsor-js-change .child-lives-with').html(childNavigation.currentChild.lives_with);

        if ($('.sponsor-js-change .child-weather').length) {
            var current_weather = $('.sponsor-js-change .child-weather').data('weather');
            var new_weather = childNavigation.currentChild.weather.css_class;
            var img_src = $('.sponsor-js-change .child-weather img').attr('src');
            $('.sponsor-js-change .child-weather').data('weather', new_weather);
            img_src = img_src.replace(current_weather, new_weather);
            $('.sponsor-js-change .child-weather img').attr('src', img_src);
        }

        var $gender = (childNavigation.currentChild.gender == 'F') ? 'Girl' : 'Boy';
        var $age = (childNavigation.currentChild.age == '') ? 'under 1' : childNavigation.currentChild.age;
        $('.sponsor-js-change .child-age').html($age);
        $('.sponsor-js-change .child-gender').html($gender);
        $('.sponsor-js-change .child-soliloquy').html(childNavigation.currentChild.soliloquy);
        $('.sponsor-js-change .child-local-time-24h').html(childNavigation.currentChild.country.time_24h);

        $('.sponsor-js-change .child-health').html(childNavigation.currentChild.health);
        $('.sponsor-js-change .child-chores').html(childNavigation.currentChild.chores);
        $('.sponsor-js-change .child-education').html(childNavigation.currentChild.education);

        var $altText = 'Choose a child to sponsor, like this little ' + childNavigation.currentChild.gender_text;
            $altText += ' from ' + childNavigation.currentChild.community.name + ', ' + childNavigation.currentChild.name;
            $altText += ' age ' + childNavigation.currentChild.age;

        var $childPhotoElement = '.child-photo img';

        $($childPhotoElement).attr('src', childNavigation.currentChild.image);
        $($childPhotoElement).attr('alt', $altText);
        var sponsorButton = $('.sponsor-button');
        $('.sponsor-child-id').val(childNavigation.currentChild.id);
        if (sponsorButton.data('text') !== undefined) {
            sponsorButton.val(sponsorButton.data('text').replace('%childname%', childNavigation.currentChild.firstname));
        }
    },
    updateCommunity: function () {
        if ($("#child-life-need").length) {
            var $communityNeedElement1 = $('#child-life-need .community-need-1 span'),
                $communityNeedElement2 = $('#child-life-need .community-need-2 span'),
                $communityNeedElement3 = $('#child-life-need .community-need-3 span'),
                $locationStatamentElement = $('#community-location-statement');

            $locationStatamentElement.html(childNavigation.currentChild.community_attribute.sac_locationStatement);

            $communityNeedElement1.html(childNavigation.currentChild.community_attribute.sac_needs1);
            $communityNeedElement1.css('background-image', 'url(' + childNavigation.currentChild.community_attribute.sac_needIcon1_path + ')');
            $communityNeedElement2.html(childNavigation.currentChild.community_attribute.sac_needs2);
            $communityNeedElement2.css('background-image', 'url(' + childNavigation.currentChild.community_attribute.sac_needIcon2_path + ')');
            $communityNeedElement3.html(childNavigation.currentChild.community_attribute.sac_needs3);
            $communityNeedElement3.css('background-image', 'url(' + childNavigation.currentChild.community_attribute.sac_needIcon3_path + ')');

            $('#how-sponsorship-helps .need-1-text').html(childNavigation.currentChild.community_attribute.sac_solutions1);
            $('#how-sponsorship-helps .need-2-text').html(childNavigation.currentChild.community_attribute.sac_solutions2);
            $('#how-sponsorship-helps .need-3-text').html(childNavigation.currentChild.community_attribute.sac_solutions3);
            $('#how-sponsorship-helps .need-1-icon').css('background-image', 'url(' + childNavigation.currentChild.community_attribute.sac_solutionIcon1_path + ')');
            $('#how-sponsorship-helps .need-2-icon').css('background-image', 'url(' + childNavigation.currentChild.community_attribute.sac_solutionIcon2_path + ')');
            $('#how-sponsorship-helps .need-3-icon').css('background-image', 'url(' + childNavigation.currentChild.community_attribute.sac_solutionIcon3_path + ')');
            $('#child-country').css('background-image', 'url(' + childNavigation.currentChild.community_attribute.sac_communityBanner + ')');
        }
    },
    disableNavigation: function () {
        var $elements = $(childNavigation.carouselId + ' .control');
        $.each($elements, function (index, element) {
            $(element).attr('disabled', true);
        });
    },
    enableNavigation: function () {
        var $elements = $(childNavigation.carouselId + ' .control');
        $.each($elements, function (index, element) {
            $(element).attr('disabled', false);
        });
    }
};

/**
 * Orphan search
 */
var orphanSearch = {
    childApiUrl: '/api/children/json/child-sponsorship/',
    continentEl: '#orphan-continent-filter',
    orphanFormEl: '#orphan-search',
    init: function () {
        orphanSearch.continentChange();
        orphanSearch.formSubmit();
    },
    continentChange: function () {
        var $element = $(orphanSearch.orphanFormEl + ' .btn-orphan-continent-filter');
        $element.click(function (e) {
            e.preventDefault();
            var $value = $(this).data('value');
            /** Set the value of the continent */
            $(orphanSearch.continentEl).val($value);
        });
    },
    formSubmit: function () {
        var $form = $(orphanSearch.orphanFormEl);
        $form.submit(function (e) {
            e.preventDefault();

            /** Trigger page loading */
            pageLoad.startLoading();

            /** Hide any leftover No Children messages */
            sponsorshipResultsMessages.hide();

            /** Serialize the form data */
            var $formData = $form.serialize();
            /** Append the page ID to the form data */
            $formData += '&cID=' + CCM_CID;

            $.ajax({
                url: orphanSearch.childApiUrl,
                context: document.body,
                data: $formData,
                dataType: 'html',
                type: 'get'
            }).done(function ($response) {
                var $responseJson = JSON.parse($response),
                    $tokenValue = $responseJson.new_token,
                    $children = $responseJson.children,
                    $childrenJson = JSON.stringify($children),
                    $totalChildren = $children.length,
                    $startIndex = 0;

                /** Complete page loading */
                pageLoad.endLoading();

                /** Update the token value with the new one from the response */
                childFilter.updateTokenValue($tokenValue);

                /** Handle no children message */
                if ($responseJson.show_no_child_notice === true) {
                    sponsorshipResultsMessages.message = $responseJson.message;
                    sponsorshipResultsMessages.show();
                }

                if ($totalChildren > 0) {
                    /** Update the child navigation values and init the childNavigation */
                    childNavigation.json = $childrenJson;
                    childNavigation.startIndex = $startIndex;
                    childNavigation.totalChildren = $totalChildren;
                    childNavigation.currentChild = $children[$startIndex];
                    childNavigation.decode();
                    childNavigation.setStartChild();
                    childNavigation.setCurrentChildIndex($startIndex);
                    childNavigation.lastChildIndex = parseInt($totalChildren) - 1;

                    /** Manually update the child result to the first of the filtered children */
                    childNavigation.updateChild();

                    /** Manually unhide the child navigation as there are some journeys that hide it */
                    childFilter.updateNavigation();
                }

                /** col-xs */
                if (window.matchMedia('screen and (max-width:767px)').matches) {
                    /** On mobile only, close the filters after searching */
                    //childFilter.deactivateAll();
                    childFilter.hideParent();
                }
            });
        });
    }
};

/**
 * Floating Sponsor a Child CTA - appears when between main Sponsorship CTA's
 */
var floatingSponsorBar = {
    docViewTop: $(window).scrollTop(),
    docViewBottom: $(window).scrollTop() + $(window).height(),
    floatingBarId: '#floating-sponsor-bar',
    topBtnSelector: '#child-results .sponsor-button',
    bottomBtnSelector: '#so-what-next .btn',
    init: function () {
        floatingSponsorBar.hideBar();
        $(window).scroll(function () {
            floatingSponsorBar.listener();
        });
    },
    listener: function () {
        if (floatingSponsorBar.canSeeTopButton() || floatingSponsorBar.canSeeBottomButton()) {
            floatingSponsorBar.hideBar();
        } else {
            floatingSponsorBar.showBar();
        }
    },
    showBar: function () {
        $(floatingSponsorBar.floatingBarId).fadeIn();
    },
    hideBar: function () {
        $(floatingSponsorBar.floatingBarId).fadeOut();
    },
    canSeeTopButton: function () {
        var $element = $(floatingSponsorBar.topBtnSelector);
        return floatingSponsorBar.elementInViewport($element, 'top');
    },
    canSeeBottomButton: function () {
        var $element = $(floatingSponsorBar.bottomBtnSelector);
        return floatingSponsorBar.elementInViewport($element, 'bottom');
    },
    elementInViewport: function (el, btn) {
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }

        var rect = el.getBoundingClientRect(),
            posTop = rect.top,
            posRight = rect.right,
            posBottom = rect.bottom,
            posLeft = rect.left;

        var inView = (
            posTop >= 0 &&
            posRight >= 0 &&
            posBottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
            posLeft <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
        );

        /** Ensure the floating bar doesn't appear when above the main sponsorship CTA */
        if (btn === 'top' && posBottom > 0) {
            inView = true;
        }

        return inView;
    }
};

/**
 * Full page loader functionality
 */
var pageLoad = {
    elementId: '#page-loading',
    startLoading: function () {
        $(pageLoad.elementId).removeClass('hide');
    },
    endLoading: function () {
        $(pageLoad.elementId).addClass('hide');
    }
};

/**
 * Handle the notifications to the user regarding their search criteria
 */
var sponsorshipResultsMessages = {
    parentEl: '#result-messages',
    alertEl: '#result-messages .alert',
    message: null,
    show: function () {
        var $parentEl = $(sponsorshipResultsMessages.parentEl),
            $alertEl = $(sponsorshipResultsMessages.alertEl);

        /** Set a new message */
        $alertEl.html(sponsorshipResultsMessages.message);
        /** Remove hide class */
        $parentEl.removeClass('hide');
        sponsorshipResultsMessages.scrollTo();
    },
    hide: function () {
        var $parentEl = $(sponsorshipResultsMessages.parentEl);
        $parentEl.addClass('hide');
    },
    scrollTo: function () {
        var $element = $(sponsorshipResultsMessages.parentEl);
        if ($element.length) {
            $('html, body').animate({
                scrollTop: $element.offset().top
            }, 500);
        }
    }
};

/**
 * Handle the country modal
 */
var countryChange = {
    element: '#country',
    selectedOption: '#country option:selected',
    init: function () {
        $(countryChange.element).change(function () {
            var $selectedElement = $(countryChange.selectedOption),
                $selected = $(countryChange.selectedOption).data('child-modal'),
                $countryId = $($selectedElement).val();

            if ($selected === 'show-modal') {
                $(this).val('any');

                $.ajax({
                    url: "/api/my-sponsorship/json/country-modal-content/?country=" + $countryId,
                    type: 'get'
                }).done(function ( data ) {
                    $('#popup-child-sponsorship-1 .modal-body').html(data);
                    $('#popup-child-sponsorship-1').modal('show');
                });
            }
        });
    }
};

var childVideo = {
    videoElementId: 'child-video',
    videoModalElementId: 'child-video-modal',
    videoElement: null,
    init: function () {
        childVideo.setVideoElement();
        childVideo.videoPause();
        childVideo.disableAutoplay();
        childVideo.disableMute();
        childVideo.disableLoop();
        childVideo.addControls();
        //childVideo.reloadVideo();
    },
    setVideoElement: function () {
        childVideo.videoElement = document.getElementById(childVideo.videoElementId);
    },
    videoPause: function () {
        childVideo.videoElement.pause();
    },
    disableAutoplay: function () {
        childVideo.videoElement.removeAttribute('autoplay');
    },
    disableMute: function () {
        childVideo.videoElement.muted = false;
    },
    disableLoop: function () {
        childVideo.videoElement.removeAttribute('loop');
    },
    reloadVideo: function () {
        childVideo.videoElement.load();
    },
    addControls: function () {
        childVideo.videoElement.setAttribute('controls', true);
    }
};

var dataLayerTracking = {
    active_child_pos: 0,
    init: function () {
        dataLayerTracking.sponsorUrl();
        dataLayerTracking.ccfm();
    },
    sponsorUrl: function () {
        $('.sponsor-button').click(function (e) {

            if (typeof dataLayer === 'undefined') {
                return false;
            }

            var active_child = childNavigation.currentChild;

            var position = childNavigation.currentChildIndex + 1;

            var payload = {
                event: 'addToCart',
                ecommerce: {
                    add: {
                        products: [{
                            name: 'Child Sponsorship',
                            id: active_child.child_id || '',
                            price: '',
                            category: 'Sponsorship/' + active_child.country.name || '',
                            variant: '',
                            quantity: 1
                        }]
                    }
                }
            };

            var buttonName = $(this).data('gtm-button');
            if (typeof buttonName !== 'undefined') {
                payload.cdX_SponsorButton = buttonName;
            }
            dataLayer.push(payload);
        });
    },
    ccfm: function () {
        // choose child for me buton
        $('.cta-ccfm-btn').click(function (e) {
            if (typeof dataLayer === 'undefined') {
                return false;
            }

            var payload = {event: 'choose-child-for-me-click'};
            dataLayer.push(payload);
        });
    },
    childChange: function (button) {
        //Carousel buttons
        if (typeof dataLayer === 'undefined') {
            return false;
        }

        var active_child = childNavigation.currentChild;

        var position = childNavigation.currentChildIndex + 1;

        var payload = {
            event: button,
            ecommerce: {
                detail: {
                    products: [{
                        name: 'Child Sponsorship',
                        id: active_child.child_id,
                        price: '',
                        category: 'Sponsorship/' + active_child.country.name,
                        variant: '',
                        quantity: 1,
                        list: 'Child Sponsorship/CS Landing',
                        position: position
                    }]
                }
            }
        };
        dataLayer.push(payload);
    }
}

/**
 * debouncing function from John Hann
 * http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
 *
 * @param func
 * @param threshold
 * @param execAsap
 * @returns {debounced}
 */
var debounce = function (func, threshold, execAsap) {
    var timeout;

    return function debounced()
    {
        var obj = this, args = arguments;
        function delayed()
        {
            if (!execAsap) {
                func.apply(obj, args);
            }
            timeout = null;
        };

        if (timeout) {
            clearTimeout(timeout);
        } else if (execAsap) {
            func.apply(obj, args);
        }

        timeout = setTimeout(delayed, threshold || 250);
    };
};

/**
 * Trigger the TBS tooltips
 * @TODO: This is a duplicate of a function in sponsor-step-2.js. Need to combine and put them central.
 */
var initTooltips = function () {
    // only do conventional tooltips on larger devices. Small ones need to be hijacked with a modal
    if (is_touch_device()) {
        $('[data-toggle="tooltip"]').click(function (e) {
            // we choose to suppress this functionality where the tooltip is attached to a critical action
            if ( !$(this).hasClass('modal-suppress') ) {
                e.preventDefault();
                var content = $(this).attr('title');
                var title = $(this).data('modal-title');
                $('#tooltip-modal .modal-body p').html(content);
                $('#tooltip-modal .modal-content .modal-header strong').html(title);
                $('#tooltip-modal').modal();
            }
        });
    } else {
        $('[data-toggle="tooltip"]').tooltip({
            container: 'body'
        });
    }

    function is_touch_device()
    {
        return 'ontouchstart' in window        // works on most browsers
            || navigator.maxTouchPoints;       // works on IE10/11 and Surface
    }
};

var initDataLayer = function () {

    var active_child_pos = childNavigation.currentChildIndex;
    var children = $.parseJSON(childNavigation.json);
    var active_child = childNavigation.currentChild;

    //GTM data layer
    // Log all children as impressions
    if (children.length || typeof dataLayer !== 'undefined') {
        var skipFirst = false;

        var payload = {
            event: 'pageViewEvent',
            ecommerce: {
            }
        };

        skipFirst = true;
        payload.ecommerce.detail = {
            products: [{
                name: 'Child Sponsorship',
                id: active_child.child_id,
                price: '',
                category: 'Sponsorship/' + active_child.country.name,
                variant: '',
                quantity: 1,
                position: 1
            }]
        };

        /*$.each(children, function(idx, child){
            if (skipFirst && idx == 0) {
                return true; // continue loop
            }

            var position = idx + 1;

            payload.ecommerce.impressions.push({
                name: 'Child Sponsorship',
                id: child.child_id,
                price: '',
                category: 'Sponsorship/' + child.country.name,
                variant: '',
                quantity: 1,
                position: position,
                list: 'Child Sponsorship/CS Landing'
            })
        });*/

        dataLayer.push(payload);
    }

};

var birthdaySearch = {
    forceClose: false,
    init: function () {
        /** col-xs */
        if (window.matchMedia('screen and (max-width:767px)').matches) {
            /** On mobile only, close the filters after searching */
            childFilter.deactivateAll();
            childFilter.hideParent();
        }
    }
};

$(function () {
    childFilter.init();
    childNavigation.init();
    countryChange.init();
    floatingSponsorBar.init();
    orphanSearch.init();
    dataLayerTracking.init();
    initTooltips();
    initDataLayer();

    /** col-xs */
    if (window.matchMedia('screen and (max-width:767px)').matches) {
        childVideo.init();
    }
});
